import { gql } from "@apollo/client"

export const GET_DISTRICT_ADMIN = gql`
  query getDistrictAdmin($id: String!) {
    districtAdmin {
      get(id: $id) {
        id
        firstName
        lastName
        email
        username
        title
        isTeacher
        isIT
      }
    }
  }
`

export const CHECK_ONBOARDING_QUERY = gql`
  query ShowOnboarding($data: DistrictAdminOnboardingCheckRequest) {
    districtAdmin {
      checkOnboarding(data: $data) {
        shouldShowOnboarding
      }
    }
  }
`

export const GET_DISTRICT_ADMINS_COUNT_QUERY = gql`
  query getDistrictAdminsCount($data: CountAdminsRequest) {
    districtAdmin {
      count(data: $data) {
        count
        activeCount
      }
    }
  }
`
